<template>
  <div id="app">
    <header id="top" class="header navbar-fixed-top">
            <div class="container">
            <h1 class="logo pull-left">
                <a class="scrollto" href="#promo">
                    <!--<img id="logo-image" class="logo-image" src="img/logo/logo_short.png" alt="Logo">-->
                    <span class="logo-title"><b>Pandaaz</b></span>
                </a>
            </h1><!--//logo-->
            <nav id="main-nav" class="main-nav navbar-right" role="navigation">
                <div class="navbar-header">
                    <button class="navbar-toggle" type="button" data-toggle="collapse" data-target="#navbar-collapse">
                        <span class="sr-only">Toggle navigation</span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button><!--//nav-toggle-->
                </div><!--//navbar-header-->
                <div class="navbar-collapse collapse" id="navbar-collapse">
                    <ul class="nav navbar-nav">
                        <li class="active nav-item sr-only"><a class="scrollto" href="#promo">Home</a></li>
                        <li class="nav-item"><a class="scrollto" data-toggle="collapse" data-target="#navbar-collapse" href="#about" >A propos</a></li>
                        <!--<li class="nav-item"><a class="scrollto" data-toggle="collapse" data-target="#navbar-collapse" href="#story">L'équipe</a></li>-->
                        <li class="nav-item"><a class="scrollto" data-toggle="collapse" data-target="#navbar-collapse" href="#project" >Projets</a></li>
                        <!--
                        <li class="nav-item"><a class="scrollto" href="#story">Story</a></li>
                        <li class="nav-item"><a class="scrollto" href="#pricing">Pricing</a></li>-->
                        <li class="nav-item last"><a class="scrollto" data-toggle="collapse" data-target="#navbar-collapse" href="#contact">Contact</a></li>
                    </ul><!--//nav-->
                </div><!--//navabr-collapse-->
            </nav><!--//main-nav-->
        </div>
    </header>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue